(function () {
  var selector = '[data-rision-c-countup]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function formatValue(value, decimals) {
    if (decimals > 0) return value.toFixed(decimals);
    return String(Math.round(value));
  }

  function animate(el) {
    var to = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(to)) return;

    var duration = parseInt(el.getAttribute('data-count-duration'), 10) || 1400;
    var decimals = parseInt(el.getAttribute('data-count-decimals'), 10) || 0;

    if (prefersReducedMotion()) {
      el.textContent = formatValue(to, decimals);
      return;
    }

    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var progress = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatValue(to * eased, decimals);
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = formatValue(to, decimals);
      }
    }

    el.textContent = formatValue(0, decimals);
    requestAnimationFrame(frame);
  }

  function init(root) {
    if (!root || root.getAttribute('data-rision-c-countup-ready') === 'true') return;

    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-rision-c-count]'));
    if (!nodes.length) return;

    root.setAttribute('data-rision-c-countup-ready', 'true');

    nodes.forEach(function (el) {
      var decimals = parseInt(el.getAttribute('data-count-decimals'), 10) || 0;
      el.textContent = formatValue(0, decimals);
    });

    function play() {
      window.setTimeout(function () {
      nodes.forEach(animate);}, 600)
    }

    if (!('IntersectionObserver' in window)) {
      play();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          play();
          observer.disconnect();
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(root);
  }

  function scan(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll(selector);
    Array.prototype.forEach.call(nodes, init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scan(document);
  }
})();
